import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Layout, Spin, Table, Row, Col, Tag, Divider, PageHeader, Breadcrumb,Switch,Tooltip,Icon } from 'antd';
import axios from 'axios';
import Moment from 'react-moment';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';
import { Constant } from '../../config';

const { Content } = Layout;
Moment.globalLocal = false;
const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Price",
  },
  {
    path: "/country",
    breadcrumbName: "Country Listing",
  },
  {
    path: "",
    breadcrumbName: "Country",
  },
];

class Country extends Component {
	state = {
		loading: false,
		dataSource: [],
	}

	columns = [
		{
      title: 'Country',
      dataIndex: 'name',
      render: (text, record)=>{
        return (
          <span>
            <span style={{fontWeight:'bold'}}>{text}</span><br />
            <Tag color="blue">Code: {record.region_code}</Tag>
            <Tag color="orange">
              Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Country Code',
      dataIndex: 'country_code',
      width:"30%",
      render: (text, record)=>{
        return (
          <div style={{wordBreak: 'break-all'}}>{record.country_code}</div>
        )
      }
    },
    {
      title: <Tooltip title="Changing status here, and there will cause a restricted country."><span>Action <Icon type="info-circle" /></span></Tooltip>,
      render: (record) => {
        return (
          <Switch onChange={(c) => this.updateStatus(record.region_code,c)} defaultChecked={!record.is_restricted} checkedChildren="Enabled" unCheckedChildren="Disabled" />
        )
      }
    }

  ]
  columnsMobile = [
    {
      title: 'Country',
      dataIndex: 'name',
      render: (text, record)=>{
        return (
          <span>
            <span style={{fontWeight:'bold'}}>{text}</span><br />
            <Tag color="blue">Code: {record.region_code}</Tag>
            <Tag color="orange">
            Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
            <Divider className="my-divider" dashed orientation="left">Country Code</Divider>
            <div style={{wordBreak: 'break-all'}}>{record.country_code}</div>
          </span>
        )
      }
    },
  ]
  currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0

	componentWillMount(){
    this.props.fetchMenuAction("country", "country")
    this.setState({loading: true})
  }

  async componentDidMount() {
  	this.setState({
  		loading: false,
  		dataSource: await this._getList(),
  	})
  }

  mySearch = (fd) => {
  	fd.validateFields(async (err, values)=>{
  		if (err)
  			return

      this.setState({loading: true})

	   	this.currentPage = 1
      this.currentSearch = values.searchTxt
      this.limit = 10
	    this.setState({
        dataSource: await this._getList(1, 10, this.currentSearch),
        loading: false
      })
  	})
  }

  resetSearch = async () => {
    this.setState({loading: true})
  	this.currentPage = 1
    this.currentSearch = ""
  	this.setState({
      dataSource: await this._getList(1, 10, ""),
      loading: false
    })
  }

  changePage = async (page, limit) => {
    this.setState({loading: true})
  	this.currentPage = page
  	this.limit = limit
  	this.setState({
      dataSource: await this._getList(
        page,
        limit,
        this.currentSearch,
      ),
      loading: false
    })
  }

  updateStatus = async (country,status) => {

    this.setState({loading: true})
    //switch status
    if(!status) {
      status = true
    }else{
      status = false
    }

    let url = Constant.COUNTRY_API+"/status/"+country+"/"+status

    let opt = {
      url,
      method: "PATCH",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }


    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    this.setState({loading: false})

    return 

  }

  _getList = async (page=1, limit=10, search="")=>{
  	let url = Constant.COUNTRY_API+"?page="+page+"&limit="+limit+"&search="+search

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
  }

	render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize:this.limit, 
        total:this.totalRows, 
        current:this.currentPage, 
        onChange:this.changePage, 
        size:"small"
      }
    }
    let propsTableForMobile = Object.assign({}, propsTable)
    propsTableForMobile.className = "my-table-mobile"
    propsTableForMobile.columns = this.columnsMobile

		return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Country</h2>} />
        <div className="my-layout">
          <Spin spinning={this.state.loading} tip="Loading...">
            <Content className="main-container">
              <div className='main-container-inner'>
                <Row className="utility-bar">
                  <Col span={12}></Col>
                  <Col span={12}><SearchForm fn={this.mySearch} fnReset={this.resetSearch} /></Col>
                </Row>
                <Row className="utility-bar-mobile">
                  <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
                </Row>
              </div>
              <Table {...propsTable} />
              <Table {...propsTableForMobile} />
            </Content>
          </Spin>
        </div>
      </Layout>
		)
	}
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
  }
}

export default connect(null, mapDispatchToProps)(Country)


// WEBPACK FOOTER //
// ./src/containers/Country/Country.js